import { makeGqlQuery } from '@/utilities/gqlQuery';
import { gql } from '@/utilities/gql';
import { NARRATIVE_FRAGMENT } from './narrativeFragment';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import { NARRATIVE_URL_COMPANY_FRAGMENT } from '../../utils/getNarrativeUrl';
import { NARRATIVE_SIDEBAR_COMPANY_FRAGMENT } from '../../components/NarrativeSidebar/narrativeSidebarFragment';
import { NARRATIVE_HEADER_COMPANY_FRAGMENT } from '../../components/NarrativeHeader/narrativeHeaderFragment';
import { COMMENT_SCHEMA_FRAGMENT } from '@/utilities/comment';
import { NARRATIVE_UPDATE_PANEL_FRAGMENT } from '../../components/NarrativeUpdatePanel';

const QUERY = gql(
  `
 query Narrative($slug: ID!) {
    narrative(ref: $slug) {
      commentKey
      ...NarrativeFields
      company {
        analysisValue {
          priceTargetAnalystCount
          return7d
          return1yAbs
          lastSharePrice
          npvPerShare
        }
        canonicalCommunityUrl
        ...NarrativeSidebarCompanyFields
        ...NarrativeUrlCompanyFields
        ...NarrativeHeaderCompanyFields
      }
      comments(limit: 5) {
        ...CommentSchemaFields
      }
      publishedUpdates {
        ...NarrativeUpdatePanelFields
      }
    }
  }
`,
  [
    NARRATIVE_FRAGMENT,
    NARRATIVE_SIDEBAR_COMPANY_FRAGMENT,
    NARRATIVE_URL_COMPANY_FRAGMENT,
    NARRATIVE_HEADER_COMPANY_FRAGMENT,
    COMMENT_SCHEMA_FRAGMENT,
    NARRATIVE_UPDATE_PANEL_FRAGMENT,
  ]
);

export const useNarrative = makeGqlQuery(QUERY, {
  staleTime: 3600000,
  tags: ['narrative', 'narrative-view'],
});

export type Narrative = ResolvedQueryData<typeof useNarrative>['narrative'];
